module.exports = __webpack_public_path__ + "img/V17.5c6d3671.png";